<template>
    <md-app>
        <md-app-toolbar class="md-primary">
            <span class="md-title">レーン決めるマン</span>
        </md-app-toolbar>
        <md-app-content>
            <span class="md-title">参加者洗濯</span>
            <div v-if="this.statusCode === 200">
                <md-list>
                    <UserComponent v-for="person in people" :key="person.name" :user-name="person.name" :user-icon="person.url" :array="checked"/>
                </md-list>
                <SubmitButton :checked="checked" :id="id"/>
            </div>
            <div v-else-if="this.statusCode === 404">
                <span>お部屋が見つからないよ</span>
            </div>
        </md-app-content>
    </md-app>
</template>

<script>
    import axios from 'axios'

    import UserComponent from '../components/UserComponent.vue'
    import SubmitButton from '../components/SubmitButton.vue'

    export default {
        name: 'Position',
        components: {
            SubmitButton,
            UserComponent
        },
        data() {
            return {
                people: [],
                checked: [],
                id: this.$route.params.id,
                statusCode: 200
            }
        },

        async mounted() {
            let response;
            try {
                response = await axios.get(`https://afty.arukascloud.io/rooms/${this.id}`);

                this.people.push(...response.data.members);
            } catch (e) {
                response = e.response;
            }
            this.statusCode = response.status;
        },
        methods: {
        }
    }
</script>

<style scoped>

</style>
